import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { MmFlexLayoutModule, MmIconModule } from '@metromarkets/components';
import {
  ProductLimitedStockLabelComponent
} from '~shared/components/product-limited-stock-label/product-limited-stock-label.component';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    RouterModule,
    MmIconModule,
    MmFlexLayoutModule,
  ],
  declarations: [
    ProductLimitedStockLabelComponent,
  ],
  exports: [
    ProductLimitedStockLabelComponent
  ]
})

export class ProductLimitedStockLabelModule {}
